export default __webpack_public_path__ + "12faaeedf7e2f1422fc8df3c58bd20c5.png";